  <template>
    <div class="container smartsheetform">
      <div class="items smartsheetform">
        <div style="width:250px">
          <img
            src="@/assets/images/resmed-logo-color.png"
            alt="Resmed product support"
            class="img-fluid mb-3"
          />
        </div>
        <div class="title mb-4">
          Astral Supercapacitor Test /
    <br/>
  R6.2 (SX544-0603) Software Upgrade
        </div>
        <p class="text-center fw-bold">Follow the updated Astral Service process detailed in Tech Note 1063673 <br/>and/or the software upgrade process detailed in Tech Notes 1063686 or<br/> 1063687, and fill in required information below.</p>
        <div class="item card-white">
          <div class="smart-card margin-card">
            <form @submit.prevent="submit">
              <div class="form-container">
                <div class="input-div">
                  <label for="contact_email" class="mandatory">Contact email</label>
                  <input
                    id="contact_email"
                    v-model="contact_email"
                    type="text"
                    name="contact_email"
                    class="input-height"
                    required
                  />
                  <span v-if="validation.contact_email" class="error">{{
                    validation.contact_email
                  }}</span>

                
                </div>

                <div class="input-div">
                  <label for="companyName" class="mandatory"
                    >Your Company Name</label
                  >
                  <input
                    id="company_name"
                    v-model="companyName"
                    type="text"
                    name="companyName"
                    class="input-height"
                  />
                  <span v-if="validation.companyName" class="error">{{
                    validation.companyName
                  }}</span>
                </div>

                <div class="input-div">
                  <label for="device_serial_number" class="mandatory"
                    >Device Serial Number</label
                  >
                  <input
                    id="device_number"
                    v-model="device_serial_number"
                    type="number"
                    name="device_serial_number"
                    class="input-height-semi"
                  />
                  <span v-if="validation.device_serial_number" class="error">{{
                    validation.device_serial_number
                  }}</span>
                </div>

                <div class="device-status-container">
                  <label for="deviceStatus" name="deviceStatus" class="mandatory"
                    >Device Status</label
                  >
                  <div>
                    <input
                      type="radio"
                      id="ds1"
                      value="In use - alarm testing / SW upgrade required"
                      v-model="deviceStatus"
                    />
                    <label for="ds1">In use - alarm testing / SW upgrade required</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="ds2"
                      value="Device scrapped / decommisioned"
                      v-model="deviceStatus"
                    />
                    <label for="ds2">Device scrapped / decommisioned</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="ds3"
                      value="Device unable to be found"
                      v-model="deviceStatus"
                    />
                    <label for="ds3">Device unable to be found</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="ds4"
                      value="No longer in managed fleet"
                      v-model="deviceStatus"
                    />
                    <label for="ds4">No longer in managed fleet</label>
                  </div>
                  <span v-if="validation.deviceStatus" class="error">{{
                    validation.deviceStatus
                  }}</span>
                </div>

                <!-- condition for the NO LOGER IN MANAGED FEET-->

                <div
                  v-if="deviceStatus === 'No longer in managed fleet'"
                  class="device-Comments-container"
                >
                <div class="input-div">
                  <label for="comments" name="Comments" class="mandatory"
                    >Comments</label
                  >
                  <div>
                    <textarea id="comments" name="comments" v-model="comments"></textarea>
                  </div>
                  <span v-if="validation.comments" class="error">{{
                    validation.comments
                  }}</span>
                  </div>
                </div>

                <!-- Content for alarm testing -->
                <div
                  v-if="deviceStatus === 'In use - alarm testing / SW upgrade required'"
                  class="alarm-testing-container"
                >
                  <label for="alarm_testing_or_software_upgrade" name="alarm_testing_or_software_upgrade" class="mandatory"
                    >Alarm testing or Software upgrade</label
                  >
                  <div>
                    <input
                      type="radio"
                      id="alarm1"
                      value="RSS Super Capacitor Test only"
                      v-model="alarm_testing_or_software_upgrade"
                    />
                    <label for="alarm1">RSS Super Capacitor Test only</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="alarm2"
                      value="RSS Super Capacitor Test AND RSS software upgrade (SX544-0603)"
                      v-model="alarm_testing_or_software_upgrade"
                    />
                    <label for="alarm2"
                      >RSS Super Capacitor Test AND RSS software upgrade
                      (SX544-0603)</label
                    >
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="alarm3"
                      value="RSS software upgrade (SX544-0603) only"
                      v-model="alarm_testing_or_software_upgrade"
                    />
                    <label for="alarm3"
                      >RSS software upgrade (SX544-0603) only</label
                    >
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="alarm4"
                      value="USB software upgrade (SX544-0603) only"
                      v-model="alarm_testing_or_software_upgrade"
                    />
                    <label for="alarm4"
                      >USB software upgrade (SX544-0603) only</label
                    >
                  </div>
                  <span v-if="validation.alarm_testing_or_software_upgrade" class="error">{{
                    validation.alarm_testing_or_software_upgrade
                  }}</span>
                </div>

                <div v-if="shouldShowContent">
                  <div class="hidden-title mb-3 mt-3">
                    Results from RSS Supercapacitor Test (Tech Note #1063673)
                  </div>
                  <!-- ... (content for RSS Supercapacitor Test) ... -->
                  <div class="input-div">
                    <label for="pcbaSno" class="mandatory"
                      >Enter PCBA Serial Number</label
                    >
                    <input
                      id="pcbaSno"
                      v-model="pcbaSno"
                      type="text"
                      name="pcbaSno"
                      class="input-height"
                    />
                    <span v-if="validation.pcbaSno" class="error">{{
                      validation.pcbaSno
                    }}</span>
                  </div>

                  <div class="input-div">
                    <label for="deviceTurnedOn10Min" class="mandatory"
                      >Has the device been turned on for 10 minutes?</label
                    >
                    <div>
                      <input
                        type="radio"
                        id="deviceTurnedOn10MinTrue"
                        value="True"
                        v-model="deviceTurnedOn10Min"
                      />
                      <label for="deviceTurnedOn10MinTrue">True</label>
                    </div>
                    <span v-if="validation.deviceTurnedOn10Min" class="error">{{
                      validation.deviceTurnedOn10Min
                    }}</span>
                  </div>

                  <div class="input-div">
                    <label for="tpfAlarmLasted5Min" class="mandatory"
                      >Did the TPF alarm last for >5minutes?</label
                    >
                    <div>
                      <input
                        type="radio"
                        id="tpfAlarmLasted5MinTrue"
                        value="True"
                        v-model="tpfAlarmLasted5Min"
                      />
                      <label for="tpfAlarmLasted5MinTrue">True</label>
                    </div>
                    <div>
                      <input
                        type="radio"
                        id="tpfAlarmLasted5MinFalse"
                        value="False"
                        v-model="tpfAlarmLasted5Min"
                      />
                      <label for="tpfAlarmLasted5MinFalse">False</label>
                    </div>
                    <div v-if="tpfAlarmLasted5Min === 'False'">
                      <p>Replace PCBA.</p>
                      <p>If device SN XXXXX, return PCBA to your local Resmed service centre.</p>
                    </div>
                    <span v-if="validation.tpfAlarmLasted5Min" class="error">{{
                      validation.tpfAlarmLasted5Min
                    }}</span>
                  </div>
                </div>


                <div 
                    v-if="
                      alarm_testing_or_software_upgrade 
                      && (alarm_testing_or_software_upgrade == 'RSS Super Capacitor Test AND RSS software upgrade (SX544-0603)' || alarm_testing_or_software_upgrade == 'RSS software upgrade (SX544-0603) only' )
                      && deviceStatus === 'In use - alarm testing / SW upgrade required'
                    "
                  > <div class="hidden-title mb-3 mt-3">
                    Result of SX544-0603 Software Upgrade
                  </div>
                  <!-- ... (content for SX544-0603 Software Upgrade) ... -->
                  <label
                    for="softwareUpgrade"
                    name="softwareUpgrade"
                    class="mandatory"
                    >RSS Software upgrade successful?</label
                  >
                  <div>
                    <input
                      type="radio"
                      id="yes"
                      value="Yes"
                      v-model="softwareUpgrade"
                    />
                    <label for="yes">Yes</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="no"
                      value="No - please specify below"
                      v-model="softwareUpgrade"
                    />
                    <label for="no">No - please specify below</label>
                  </div>
                  <span v-if="validation.softwareUpgrade" class="error">{{
                    validation.softwareUpgrade
                  }}</span>
                </div>



                <div 
                    v-if="
                      alarm_testing_or_software_upgrade 
                      && alarm_testing_or_software_upgrade == 'USB software upgrade (SX544-0603) only' 
                      && deviceStatus === 'In use - alarm testing / SW upgrade required'
                    "
                  >                <div class="hidden-title mb-3 mt-3">
                    Result of SX544-0603 Software Upgrade
                  </div>
                  <!-- ... (content for SX544-0603 Software Upgrade) ... -->
                  <label
                    for="softwareUpgrade"
                    name="softwareUpgrade"
                    class="mandatory"
                    >USB SW upgrade successful</label
                  >
                  <div>
                    <input
                      type="radio"
                      id="yes"
                      value="True"
                      v-model="softwareUpgrade"
                    />
                    <label for="yes">True</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="no"
                      value="False"
                      v-model="softwareUpgrade"
                    />
                    <label for="no">False</label>
                  </div>
                  <div v-if="softwareUpgrade === 'False'">
                    <p>Return to service centre</p>
                  </div>
                  <span v-if="validation.softwareUpgrade" class="error">{{
                    validation.softwareUpgrade
                  }}</span>
                </div>

                <div v-if="softwareUpgrade === 'False' && deviceStatus === 'In use - alarm testing / SW upgrade required' && (alarm_testing_or_software_upgrade === 'USB software upgrade (SX544-0603) only')">
                  <div class="issue-div">
                    <label for="issue" class="mandatory"
                      >What was the issue?</label
                    >
                    <input
                      id="issue"
                      v-model="issue"
                      type="text"
                      name="issue"
                      class="input-height"
                    />
                  </div>
                  <span v-if="validation.issue" class="error">{{
                    validation.issue
                  }}</span>
                </div>

                <div v-if="deviceStatus == 'In use - alarm testing / SW upgrade required' && alarm_testing_or_software_upgrade === 'USB software upgrade (SX544-0603) only' && softwareUpgrade ==='True' ">
                  <div class="turnoff-device-title mandatory mb-2 mt-3">
                    Has the device been turned on for 10 minutes?
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="deviceOn10Min"
                      value="True"
                      v-model="deviceOn10Min"
                    />
                    <label for="deviceOn10Min">True</label>
                  </div>
                  <span v-if="validation.deviceOn10Min" class="error">{{
                    validation.deviceOn10Min
                  }}</span>
                </div>

                <div v-if="deviceOn10Min === 'True' && deviceStatus == 'In use - alarm testing / SW upgrade required' && alarm_testing_or_software_upgrade === 'USB software upgrade (SX544-0603) only' && softwareUpgrade ==='True'">
                  <div class="paragraph">
                    Leave the device on for 20 minutes or until it displays a system fault, whichever is shorter. If it displays a system fault, return the device for service.
                  </div>
                </div>
                <div v-if="deviceOn10Min === 'True' && deviceStatus == 'In use - alarm testing / SW upgrade required' && alarm_testing_or_software_upgrade === 'USB software upgrade (SX544-0603) only' && softwareUpgrade ==='True'"  class="returnDevice">
                 Return the device to service
>>>>>>> Stashed changes

                </div>
                <div class="border-div"></div>
          
                <div>
                  <input
                    type="checkbox"
                    id="emailVerification"
                    v-model="emailVerification"
                  />
                  <label for="emailVerification"
                    >Send me a copy of my responses</label
                  >
                </div>

                <div v-if="emailVerification" class="device-Comments-container mt-3" >
                  <label for="emailComment" class="mandatory">Email address</label>
                  <div>
                    <input
                      id="emailComment"
                      v-model="emailComment"
                      type="text"
                      name="emailComment"
                      class="input-height"
                    />
                  </div>
                   <span v-if="validation.emailComment" class="error">{{
                    validation.emailComment
                  }}</span>
                </div>

                <div class="submit-btn-wrap">
                  <button type="submit" class="submit-btn">Submit</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </template>

  {/* <style>
  .container.smartsheetform {
    margin: 40px;
  }

  .mandatory::after {
    content: " *";
    color: rgb(208, 1, 27);
  }

  .form-container {
    padding: 30px 25px;
  }
  .hidden-title {
    font-size: 22px;
    font-weight: 300px;
    color: rgb(22, 22, 22);
  }
  .turnoff-device-title {
    font-size: 0.87rem;
    font-weight: bold;
    color: rgb(22, 22, 22);
  }
  .title {
    font-size: 32px;
    font-weight: bold;
    text-align: center;
  }
  .alarm-testing-container {
    margin-top: 10px;
  }
  .paragraph {
    font-size: 0.87rem;
  }
  .returnDevice {
    color: rgb(22, 22, 22);
    font-size: 1.2em;
    font-weight: 300;
    margin: 20px 0px;
  }
  .issue-div {
    margin-top: 10px;
    font-size: 0.87rem;
    font-weight: bold;
  }
  .items.smartsheetform {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .card-white {
    width: 600px;
    height: 100%;
  }

  .smart-card {
    width: 600px;
  }

  .input-div {
    margin-bottom: 15px;
  }


  .border-div {
    border-bottom: 2px solid lightgray;
    margin: 20px 0px;
  }

  .submit-btn {
    padding: 10px 20px;
    background-color: rgb(0, 115, 236);
    color: white;
    border-radius: 2px;
  }

  .submit-btn-wrap {
    margin: 20px 0px;
  }

  .input-height {
    width: 550px;
    height: 30px;
  }

  .input-height-semi {
    width: 250px;
    height: 30px;
  }

  .is-invalid {
    border-color: rgb(208, 1, 27);
  }

  .error {
    color: rgb(208, 1, 27);
  }
  </style>  */}


  <script>
  import Swal from 'sweetalert2';

  export default {
    name: "SmartSheetForm",
    data() {
      return {
        contact_email: null,
        companyName: null,
        device_serial_number: null,
        deviceStatus: null,
        alarm_testing_or_software_upgrade: null,
        pcbaSno: null,
        softwareUpgrade: null,
        issue: null,
        deviceOn: null,
        deviceOff: null,
        emailVerification: false,
        emailComment: null,
        returnDeviceText: null,
        comments:null,
        deviceTurnedOn10Min: null,
        tpfAlarmLasted5Min: null,
        deviceOn10Min: null,

        // Validation errors
        validation: {},

        // Submission status
        status: {
          errors: false,
          submitting: false,
          success: false,
          errorMessage: null,
        },
      };
    },
    methods: {
      // Centralized validation logic
      validateField(fieldName) {
        const value = this[fieldName];
        let error = null;

        switch (fieldName) {
          case "contact_email":
            if (!value) error = "Email is required";
            else if (
              !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).toLowerCase())
            ) {
              error = "Invalid email format";
            }
            break;

          case "companyName":
          case "device_serial_number":
            if (!value) error = `${fieldName} is required`;
            break;

          case "deviceStatus":
            if (!value) error = "Device status is required";
            break;

          case "alarm_testing_or_software_upgrade":
            if (this.deviceStatus === "In use - alarm testing required" && !value)
              error = "Please select an alarm testing option";
            break;

          case "pcbaSno":
            if (this.alarm_testing_or_software_upgrade && (this.alarm_testing_or_software_upgrade === "RSS Super Capacitor Test only" || this.alarm_testing_or_software_upgrade === "RSS Super Capacitor Test AND RSS software upgrade (SX544-0603)") && !value)
              error = `${fieldName} is required`;
            break;

          case "deviceTurnedOn10Min":
            if (this.shouldShowContent && !value)
              error = "Please confirm if the device was turned on for 10 minutes";
            break;

          case "tpfAlarmLasted5Min":
            if (this.shouldShowContent && !value)
              error = "Please confirm if the TPF alarm lasted for >5 minutes";
            break;

          case "softwareUpgrade":
            if (this.alarm_testing_or_software_upgrade && (this.alarm_testing_or_software_upgrade === "RSS Super Capacitor Test AND RSS software upgrade (SX544-0603)" || this.alarm_testing_or_software_upgrade === "RSS software upgrade (SX544-0603) only" || this.alarm_testing_or_software_upgrade === "USB software upgrade (SX544-0603) only") && !value) error = "Software upgrade status is required";
            break;

          case "issue":
            if (
              this.softwareUpgrade === "False" &&
              this.deviceStatus === 'In use - alarm testing / SW upgrade required' &&
              this.alarm_testing_or_software_upgrade === 'USB software upgrade (SX544-0603) only' &&
              !value
            ) {
              error = "Please specify the issue";
            }
            break;

          case "deviceOn10Min":
            if (this.deviceStatus === 'In use - alarm testing / SW upgrade required' && this.alarm_testing_or_software_upgrade === 'USB software upgrade (SX544-0603) only' && this.softwareUpgrade === 'True' && !value) error = "Please confirm if the device was turned on for 10 minutes";
            break;

          case "comments":
            if (this.deviceStatus === "No longer in managed fleet" && !value) 
            error = "Comments are required";
            break;

          case "emailComment":
            if (this.emailVerification && !value)
              error = "Email address is required for email verification";
            break;

          default:
            break;
        }

        this.$set(this.validation, fieldName, error);
        return !error;
      },

      // Validate all fields
      validateForm() {
        const fieldsToValidate = [
          "contact_email",
          "companyName",
          "device_serial_number",
          "deviceStatus",
          "alarm_testing_or_software_upgrade",
          "pcbaSno",
          "deviceTurnedOn10Min",
          "tpfAlarmLasted5Min",
          "softwareUpgrade",
          "issue",
          "deviceOn10Min",
          "emailComment",
          "comments",
        ];

        const isValid = fieldsToValidate.every((field) =>
          this.validateField(field)
        );
        this.status.errors = !isValid;
        return isValid;
      },

      // Submit the form
      async submit() {
        if (this.validateForm()) {
          this.status.submitting = true;
          this.status.success = false;
          this.status.errorMessage = null;


          const payload = {
            data: {
              contact_email: this.contact_email,
              company_name: this.companyName,
              device_serial_number: this.device_serial_number,
              device_status: this.deviceStatus,
              alarm_testing_or_software_upgrade: this.alarm_testing_or_software_upgrade,
              pcba_serial_number: this.pcbaSno,
              device_turned_on_10_min: this.deviceTurnedOn10Min,
              tpf_alarm_lasted_5_min: this.tpfAlarmLasted5Min,
              software_upgraded: this.softwareUpgrade,
              issue: this.issue,
              device_on_10_min: this.deviceOn10Min,
              send_email: this.emailVerification,
              email_address: this.emailComment,
              comments: this.comments
            }
        }


        // Convert null values to empty strings
        for (const key in payload.data) {

          if (payload.data[key] === null) {

            payload.data[key] = "";

          }

        }

        try {
          const response = await fetch(`${process.env.VUE_APP_GPSPOD_ENDPOINT}/gps/home/uploadForm?astral=true`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          });

            await response.json(); 
            this.status.success = true;
            Swal.fire({
              title: 'Success!',
              text: 'Form submitted successfully.',
              icon: 'success',
              confirmButtonText: 'OK',
            });
          } catch (error) {
            // console.error("Error submitting form:", error); // Removed console.error
            this.status.errorMessage = "Failed to submit the form.";
            Swal.fire({
              title: 'Error!',
              text: 'Failed to submit the form.',
              icon: 'error',
              confirmButtonText: 'OK',
            });        } finally {
            this.status.submitting = false;
          }
        } else {
          // console.log("Form validation failed", this.validation); // Removed console.log
        }
      },
    },
    computed: {
      shouldShowContent() {
        return (
          (this.alarm_testing_or_software_upgrade === 'RSS Super Capacitor Test only' || 
          this.alarm_testing_or_software_upgrade === 'RSS Super Capacitor Test AND RSS software upgrade (SX544-0603)') &&
          this.deviceStatus == 'In use - alarm testing / SW upgrade required'
        );
      }
    }, 
  };
  </script>
